import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/Actions/actions";
import "../Column.scss";
import ColorPicker from "../../../Tool/ColorPicker/ColorPicker";
import cloneDeep from "lodash.clonedeep";
import * as UTILS from "../../../../utils/Utils";
import Counter from "../../../Tool/Counter/Counter";
import Popup from "../../../Modal/Popup";
import ImagesContent from "../../../Modal/Library/Content/ImagesContent";
import UnitSelector from "../../../Tool/UnitSelector/UnitSelector";
import {
  Alert,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Collapse,
} from "reactstrap";
import Axios from "../../../../axios";
class ColumnBG extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bgImage: this.props.BgImage,
      bgImageId: null,
      showSettings: false,
      colorPicker: false,
      borderColorPicker: false,
      bgColorPicker: false,
      enableLibrary: false,
      selectedImage: null,
      cropImage: null,
      croppedImage: null,
      toggleBackgroundSettings: false,
    };
  }
  componentDidMount = () => {
    this.setState({
      mobileGutter:
        this.props.gutterSpaceMobile > 0 ||
        this.props.gutterSpaceMobile > "0" ||
        this.props.gutterSpaceMobileLeft > 0 ||
        this.props.gutterSpaceMobileLeft > "0" ||
        this.props.gutterSpaceMobileRight > 0 ||
        this.props.gutterSpaceMobileRight > "0" ||
        this.props.gutterSpaceTopBottomMobile > "0" ||
        this.props.gutterSpaceTopBottomMobile > 0 ||
        this.props.gutterSpaceTopBottomMobileTop > "0" ||
        this.props.gutterSpaceTopBottomMobileTop > 0 ||
        this.props.gutterSpaceTopBottomMobileBottom > "0" ||
        this.props.gutterSpaceTopBottomMobileBottom > 0
          ? true
          : false,
    });
  };
  cropImage = () => {
    const dataUrl = this.cropper.getCroppedCanvas().toDataURL();
    this.setState({
      croppedImage: dataUrl,
    });
  };

  getImageContent = (content) => {
    this.setState(
      {
        bgImage: content.image,
        bgImageId: content.id,
        selectedImage: content.image,
      },
      () => {
        let layout = JSON.parse(JSON.stringify(this.props.layout));
        let columnNumber = this.props.ColumnNumber;
        const newLayout = UTILS.UpdateLayout(
          layout,
          this.props.ID,
          (item) => {
            item.columnsBG[columnNumber].bgImage = this.state.bgImage;
          },
          (colItem) => {
            colItem.columnsBG[columnNumber].bgImage = this.state.bgImage;
          },
          (colItemNested) => {
            colItemNested.columnsBG[columnNumber].bgImage = this.state.bgImage;
          }
        );
        this.props.layoutArray(this.props.layoutTitle, newLayout);
      }
    );
  };
  bgRepeat = (e) => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber].bgRepeat = e.target.checked
          ? "repeat"
          : "no-repeat";
        item.columnsBG[columnNumber].bgSize = e.target.checked
          ? "auto"
          : item.columnsBG[columnNumber].bgSize;
      },
      (colItem) => {
        colItem.columnsBG[columnNumber].bgRepeat = e.target.checked
          ? "repeat"
          : "no-repeat";
        colItem.columnsBG[columnNumber].bgSize = e.target.checked
          ? "auto"
          : colItem.columnsBG[columnNumber].bgSize;
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber].bgRepeat = e.target.checked
          ? "repeat"
          : "no-repeat";
        colItemNested.columnsBG[columnNumber].bgSize = e.target.checked
          ? "auto"
          : colItemNested.columnsBG[columnNumber].bgSize;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  bgSize = (e) => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber].bgSize = e.target.checked
          ? "cover"
          : "auto";
      },
      (colItem) => {
        colItem.columnsBG[columnNumber].bgSize = e.target.checked
          ? "cover"
          : "auto";
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber].bgSize = e.target.checked
          ? "cover"
          : "auto";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  removeBg = () => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber].bgImage = "";
        item.columnsBG[columnNumber].bgColor = "#ffffff";
      },
      (colItem) => {
        colItem.columnsBG[columnNumber].bgImage = "";
        colItem.columnsBG[columnNumber].bgColor = "#ffffff";
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber].bgImage = "";
        colItemNested.columnsBG[columnNumber].bgColor = "#ffffff";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  bgColorhandleChange = (e, property) => {
    let newColor = e.rgb;
    let layout = JSON.parse(JSON.stringify(this.props.layout));
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber][property] = newColor;
      },
      (colItem) => {
        colItem.columnsBG[columnNumber][property] = newColor;
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber][property] = newColor;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber][property] = selectedValue;
      },
      (colItem) => {
        colItem.columnsBG[columnNumber][property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber][property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  unitValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber][property] = selectedValue;
      },
      (colItem) => {
        colItem.columnsBG[columnNumber][property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber][property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber][property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      },
      (colItem) => {
        colItem.columnsBG[columnNumber][property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber][property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value > 1 ? value : "1";
    let columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber][property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      },
      (colItem) => {
        colItem.columnsBG[columnNumber][property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber][property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  resetMobileGutterSpace = () => {
    const layout = cloneDeep(this.props.layout);
    const columnNumber = this.props.ColumnNumber;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber].gutterSpaceMobile = "0";
        item.columnsBG[columnNumber].gutterSpaceMobileLeft = "0";
        item.columnsBG[columnNumber].gutterSpaceMobileRight = "0";
        item.columnsBG[columnNumber].gutterSpaceTopBottomMobile = "0";
        item.columnsBG[columnNumber].gutterSpaceTopBottomMobileTop = "0";
        item.columnsBG[columnNumber].gutterSpaceTopBottomMobileBottom = "0";
      },
      (colItem) => {
        colItem.columnsBG[columnNumber].gutterSpaceMobile = "0";
        colItem.columnsBG[columnNumber].gutterSpaceMobileLeft = "0";
        colItem.columnsBG[columnNumber].gutterSpaceMobileRight = "0";
        colItem.columnsBG[columnNumber].gutterSpaceTopBottomMobile = "0";
        colItem.columnsBG[columnNumber].gutterSpaceTopBottomMobileTop = "0";
        colItem.columnsBG[columnNumber].gutterSpaceTopBottomMobileBottom = "0";
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber].gutterSpaceMobile = "0";
        colItemNested.columnsBG[columnNumber].gutterSpaceMobileLeft = "0";
        colItemNested.columnsBG[columnNumber].gutterSpaceMobileRight = "0";
        colItemNested.columnsBG[columnNumber].gutterSpaceTopBottomMobile = "0";
        colItemNested.columnsBG[columnNumber].gutterSpaceTopBottomMobileTop =
          "0";
        colItemNested.columnsBG[columnNumber].gutterSpaceTopBottomMobileBottom =
          "0";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
    this.setState({
      mobileGutter: false,
    });
  };
  selectBgImage = (image) => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));
    let columnNumber = this.props.ColumnNumber;
    const selectedImage = image.image_thumb;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber].bgImage = selectedImage;
      },
      (colItem) => {
        colItem.columnsBG[columnNumber].bgImage = selectedImage;
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber].bgImage = selectedImage;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  cropAndApplyImage = () => {
    let layout = cloneDeep(this.props.layout);
    let columnNumber = this.props.ColumnNumber;
    const selectedImage = this.state.croppedImage;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber].bgImage = selectedImage;
      },
      (colItem) => {
        colItem.columnsBG[columnNumber].bgImage = selectedImage;
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber].bgImage = selectedImage;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  cloneColumn = () => {
    let itemToAdd = null;
    const cloneList = cloneDeep(this.props.layout);
    let columnToAdd = {};
    cloneList.map((item, index) => {
      if (item.id == this.props.ID) {
        itemToAdd = item;
      }
      if (item.columns && item.id !== this.props.ID) {
        return Object.keys(item.columns).map((colm, colIndex) => {
          item.columns[colm].map((colmItem, colmIndex) => {
            if (colmItem.id == this.props.ID) {
              itemToAdd = colmItem;
            }
          });
        });
      }
    });
    let indexToAdd = itemToAdd && Object.keys(itemToAdd.columns).length + 1;
    let columnKey = indexToAdd && "c" + indexToAdd;
    let columnsData = cloneDeep(itemToAdd.columns[this.props.ColumnNumber]);
    columnToAdd[columnKey] = columnsData.map((item, index) => {
      item.id = "f" + shortid();
      return item;
    });
    // Add new column
    columnToAdd && Object.assign(itemToAdd.columns, columnToAdd);

    // Column style
    itemToAdd.columnsBG[columnKey] =
      itemToAdd.columnsBG[this.props.ColumnNumber];
    // Width
    itemToAdd.deskWidth.splice(indexToAdd, 0, 50);
    Object.keys(itemToAdd.columns).length > 1 && itemToAdd.deskWidth[0] == 100
      ? (itemToAdd.deskWidth[0] = 50)
      : null;

    const newLayout = UTILS.UpdateLayout(
      cloneList,
      this.props.ID,
      (item) => {
        item = itemToAdd;
      },
      (colItem) => {
        colItem = itemToAdd;
      },
      (colItemNested) => {
        colItemNested = itemToAdd;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  resetBackground = () => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));
    let columnNumber = this.props.ColumnNumber;
    const selectedImage = this.state.croppedImage;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.columnsBG[columnNumber].bgImage = null;
        item.columnsBG[columnNumber].bgColor = "transparent";
      },
      (colItem) => {
        colItem.columnsBG[columnNumber].bgImage = null;
        colItem.columnsBG[columnNumber].bgColor = "transparent";
      },
      (colItemNested) => {
        colItemNested.columnsBG[columnNumber].bgImage = null;
        colItemNested.columnsBG[columnNumber].bgColor = "transparent";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  hideColumnOnMobile = (e) => {
    let layout = JSON.parse(JSON.stringify(this.props.layout));
    let columnNumber = this.props.ColumnNumber;
    let itemToAdd = null;
    layout.map((item, index) => {
      if (item.id == this.props.ID) {
        item.hideColumnOnMobile ? null : (item.hideColumnOnMobile = []);
        itemToAdd = item;
        return item;
      }
      if (item.columns && item.id !== this.props.ID) {
        return Object.keys(item.columns).map((colm, colIndex) => {
          return item.columns[colm].map((colmItem, colmIndex) => {
            if (colmItem.id == this.props.ID) {
              colmItem.hideColumnOnMobile
                ? null
                : (colmItem.hideColumnOnMobile = []);
              itemToAdd = colmItem;
              return colmItem;
            }
            if (colmItem.columns && colmItem.id !== this.props.ID) {
              return Object.keys(colmItem.columns).map((nest, nestIndex) => {
                return colmItem.columns[nest].map(
                  (colmNestItem, colmNestIndex) => {
                    if (colmNestItem.id == this.props.ID) {
                      colmNestItem.hideColumnOnMobile
                        ? null
                        : (colmNestItem.hideColumnOnMobile = []);
                      itemToAdd = colmNestItem;
                      return colmNestItem;
                    }
                  }
                );
              });
            }
          });
        });
      }
    });
    let hideColumnOnMobile = itemToAdd.hideColumnOnMobile.find(
      (item, index) => {
        return columnNumber == item;
      }
    )
      ? true
      : false;
    hideColumnOnMobile
      ? itemToAdd.hideColumnOnMobile.map((item, index) => {
          if (item == columnNumber) {
            itemToAdd.hideColumnOnMobile.splice(index, 1);
          }
        })
      : itemToAdd.hideColumnOnMobile.splice(0, 0, columnNumber);
    // this.props.layoutArray(this.props.layoutTitle, newLayout);
    //
    const newLayout =
      itemToAdd.hideColumnOnMobile &&
      UTILS.UpdateLayout(
        layout,
        this.props.ID,
        (item) => {
          item = itemToAdd;
        },
        (colItem) => {
          colItem = itemToAdd;
        },
        (colItemNested) => {
          colItemNested = itemToAdd;
        }
      );
    itemToAdd.hideColumnOnMobile &&
      this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  convertBase64Image = () => {
    let base64ContentArray = this.state.croppedImage.split(",");
    let mimeType = this.state.croppedImage.match(
      /[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/
    )[0];
    let imageExt = mimeType.substr(mimeType.lastIndexOf("/") + 1);
    let base64Data = base64ContentArray[1];
    const data = {
      u: this.props.userID,
      sn: this.props.sessionID,
      tp: "base64",
      ext: imageExt,
      fullsize: base64Data,
    };

    Axios.MediaService.POST_MEDIA(data)
      .then((response) => {
        this.cropAndApplyImage(response.srcUrl);
        if (response.status == 200) {
          this.setState({
            loading: false,
            cropImage: null,
          });
        }
      })
      .catch((error) => {
        // Error
      });
  };

  render() {
    const mobileGutter = this.state.mobileGutter;
    return (
      <Fragment>
        <div className="columnBGSettings--wrapper noSelect columnSettingSection">
          <div className="columnBGSettings columnPosition">
            <span
              onClick={() => {
                this.setState({
                  showSettings: !this.state.showSettings,
                });
              }}
            >
              {" "}
              Column Settings
            </span>
          </div>
          {/* {this.props.element.deskWidth && this.props.element.deskWidth.length <= 5 && (
          <div className="columnBGSettings cloneColumn">
            <span onClick={this.cloneColumn}>
              <img src={CloneICON} />
            </span>
          </div>
        )} */}
        </div>
        {this.state.showSettings == true && (
          <Popup
            width="700"
            header="Column Settings"
            closePopup={() => {
              this.setState({
                showSettings: false,
                enableLibrary: false,
                cropImage: null,
                borderColorPicker: false,
                selectedImage: null,
              });
            }}
            close={() => {
              this.setState({
                showSettings: false,
                enableLibrary: false,
                cropImage: null,
                borderColorPicker: false,
              });
            }}
          >
            <div className="modalScrollContainerSecondary">
              <div className="columnStyle--wrapper">
                <div className="columnStyle--modal">
                  <div
                    style={{ marginTop: "10px", marginBottom: "5px" }}
                    className="padding-section"
                  >
                    <div className="heading">Padding</div>
                  </div>

                  <div
                    className="heading-row modalContentWrapper"
                    style={{ justifyContent: "flex-end" }}
                  >
                    <UnitSelector
                      value={
                        this.props.gutterSpaceUnit
                          ? this.props.gutterSpaceUnit
                          : "px"
                      }
                      onChange={(e) => {
                        this.unitValueChange(e, "gutterSpaceUnit");
                      }}
                    />
                  </div>
                  <div
                    className="modalContentWrapper"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                      }}
                    >
                      <div className="heading-row">
                        <div>Desktop</div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <div className="d-block">
                          {" "}
                          <Counter
                            label="Top"
                            // small="Top & Bottom - Desktop"
                            small={
                              this.props.gutterSpaceUnit === "%"
                                ? "percent"
                                : "pixel"
                            }
                            minusClick={() =>
                              this.counterMinus(
                                this.props.gutterSpaceTopBottom_T
                                  ? this.props.gutterSpaceTopBottom_T
                                  : this.props.gutterSpaceTopBottom
                                  ? this.props.gutterSpaceTopBottom
                                  : "0",
                                "gutterSpaceTopBottom_T"
                              )
                            }
                            valueContent={
                              this.props.gutterSpaceTopBottom_T
                                ? this.props.gutterSpaceTopBottom_T
                                : this.props.gutterSpaceTopBottom
                                ? this.props.gutterSpaceTopBottom
                                : "0"
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "gutterSpaceTopBottom_T");
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                this.props.gutterSpaceTopBottom_T
                                  ? this.props.gutterSpaceTopBottom_T
                                  : this.props.gutterSpaceTopBottom
                                  ? this.props.gutterSpaceTopBottom
                                  : "0",
                                "gutterSpaceTopBottom_T"
                              )
                            }
                          />
                        </div>

                        <div className="d-block">
                          <Counter
                            label="Bottom"
                            // small="Top & Bottom - Desktop"
                            small={
                              this.props.gutterSpaceUnit === "%"
                                ? "percent"
                                : "pixel"
                            }
                            minusClick={() =>
                              this.counterMinus(
                                this.props.gutterSpaceTopBottom_B
                                  ? this.props.gutterSpaceTopBottom_B
                                  : this.props.gutterSpaceTopBottom
                                  ? this.props.gutterSpaceTopBottom
                                  : "0",
                                "gutterSpaceTopBottom_B"
                              )
                            }
                            valueContent={
                              this.props.gutterSpaceTopBottom_B
                                ? this.props.gutterSpaceTopBottom_B
                                : this.props.gutterSpaceTopBottom
                                ? this.props.gutterSpaceTopBottom
                                : "0"
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "gutterSpaceTopBottom_B");
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                this.props.gutterSpaceTopBottom_B
                                  ? this.props.gutterSpaceTopBottom_B
                                  : this.props.gutterSpaceTopBottom
                                  ? this.props.gutterSpaceTopBottom
                                  : "0",
                                "gutterSpaceTopBottom_B"
                              )
                            }
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <div className="d-block">
                          <Counter
                            label="Left"
                            // small=" - Desktop"
                            small={
                              this.props.gutterSpaceUnit === "%"
                                ? "percent"
                                : "pixel"
                            }
                            minusClick={() =>
                              this.counterMinus(
                                this.props.gutterSpaceLeft
                                  ? this.props.gutterSpaceLeft
                                  : this.props.gutterSpace
                                  ? this.props.gutterSpace
                                  : "15",
                                "gutterSpaceLeft"
                              )
                            }
                            valueContent={
                              this.props.gutterSpaceLeft
                                ? this.props.gutterSpaceLeft
                                : this.props.gutterSpace
                                ? this.props.gutterSpace
                                : "15"
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "gutterSpaceLeft");
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                this.props.gutterSpaceLeft
                                  ? this.props.gutterSpaceLeft
                                  : this.props.gutterSpace
                                  ? this.props.gutterSpace
                                  : "15",
                                "gutterSpaceLeft"
                              )
                            }
                          />
                        </div>
                        <div className="d-block">
                          <Counter
                            label="Right"
                            // small=" - Desktop"
                            small={
                              this.props.gutterSpaceUnit === "%"
                                ? "percent"
                                : "pixel"
                            }
                            minusClick={() =>
                              this.counterMinus(
                                this.props.gutterSpaceRight
                                  ? this.props.gutterSpaceRight
                                  : this.props.gutterSpace
                                  ? this.props.gutterSpace
                                  : "15",
                                "gutterSpaceRight"
                              )
                            }
                            valueContent={
                              this.props.gutterSpaceRight
                                ? this.props.gutterSpaceRight
                                : this.props.gutterSpace
                                ? this.props.gutterSpace
                                : "15"
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "gutterSpaceRight");
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                this.props.gutterSpaceRight
                                  ? this.props.gutterSpaceRight
                                  : this.props.gutterSpace
                                  ? this.props.gutterSpace
                                  : "15",
                                "gutterSpaceRight"
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                      }}
                    >
                      <div className="heading-row">
                        <div>Mobile</div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <div className="d-block">
                          <Counter
                            label="Top"
                            // small="Top & Bottom - Mobile"
                            small={
                              this.props.gutterSpaceUnit === "%"
                                ? "percent"
                                : "pixel"
                            }
                            minusClick={() =>
                              this.counterMinus(
                                this.props.gutterSpaceTopBottomMobileTop
                                  ? this.props.gutterSpaceTopBottomMobileTop
                                  : this.props.gutterSpaceTopBottomMobile
                                  ? this.props.gutterSpaceTopBottomMobile
                                  : "0",
                                "gutterSpaceTopBottomMobileTop"
                              )
                            }
                            valueContent={
                              this.props.gutterSpaceTopBottomMobileTop
                                ? this.props.gutterSpaceTopBottomMobileTop
                                : this.props.gutterSpaceTopBottomMobile
                                ? this.props.gutterSpaceTopBottomMobile
                                : "0"
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(
                                e,
                                "gutterSpaceTopBottomMobileTop"
                              );
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                this.props.gutterSpaceTopBottomMobileTop
                                  ? this.props.gutterSpaceTopBottomMobileTop
                                  : this.props.gutterSpaceTopBottomMobile
                                  ? this.props.gutterSpaceTopBottomMobile
                                  : "0",
                                "gutterSpaceTopBottomMobileTop"
                              )
                            }
                          />
                        </div>
                        <div className="d-block">
                          <Counter
                            label="Bottom"
                            // small="Top & Bottom - Mobile"
                            small={
                              this.props.gutterSpaceUnit === "%"
                                ? "percent"
                                : "pixel"
                            }
                            minusClick={() =>
                              this.counterMinus(
                                this.props.gutterSpaceTopBottomMobileBottom
                                  ? this.props.gutterSpaceTopBottomMobileBottom
                                  : this.props.gutterSpaceTopBottomMobile
                                  ? this.props.gutterSpaceTopBottomMobile
                                  : "0",
                                "gutterSpaceTopBottomMobileBottom"
                              )
                            }
                            valueContent={
                              this.props.gutterSpaceTopBottomMobileBottom
                                ? this.props.gutterSpaceTopBottomMobileBottom
                                : this.props.gutterSpaceTopBottomMobile
                                ? this.props.gutterSpaceTopBottomMobile
                                : "0"
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(
                                e,
                                "gutterSpaceTopBottomMobileBottom"
                              );
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                this.props.gutterSpaceTopBottomMobileBottom
                                  ? this.props.gutterSpaceTopBottomMobileBottom
                                  : this.props.gutterSpaceTopBottomMobile
                                  ? this.props.gutterSpaceTopBottomMobile
                                  : "0",
                                "gutterSpaceTopBottomMobileBottom"
                              )
                            }
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <div className="d-block">
                          <Counter
                            label="Left"
                            // small="Left & Right - Mobile"
                            small={
                              this.props.gutterSpaceUnit === "%"
                                ? "percent"
                                : "pixel"
                            }
                            minusClick={() =>
                              this.counterMinus(
                                this.props.gutterSpaceMobileLeft
                                  ? this.props.gutterSpaceMobileLeft
                                  : this.props.gutterSpaceMobile
                                  ? this.props.gutterSpaceMobile
                                  : "0",
                                "gutterSpaceMobileLeft"
                              )
                            }
                            valueContent={
                              this.props.gutterSpaceMobileLeft
                                ? this.props.gutterSpaceMobileLeft
                                : this.props.gutterSpaceMobile
                                ? this.props.gutterSpaceMobile
                                : "0"
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "gutterSpaceMobileLeft");
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                this.props.gutterSpaceMobileLeft
                                  ? this.props.gutterSpaceMobileLeft
                                  : this.props.gutterSpaceMobile
                                  ? this.props.gutterSpaceMobile
                                  : "0",
                                "gutterSpaceMobileLeft"
                              )
                            }
                          />
                        </div>
                        <div className="d-block">
                          <Counter
                            label="Right"
                            // small="Left & Right - Mobile"
                            small={
                              this.props.gutterSpaceUnit === "%"
                                ? "percent"
                                : "pixel"
                            }
                            minusClick={() =>
                              this.counterMinus(
                                this.props.gutterSpaceMobileRight
                                  ? this.props.gutterSpaceMobileRight
                                  : this.props.gutterSpaceMobile
                                  ? this.props.gutterSpaceMobile
                                  : "0",
                                "gutterSpaceMobileRight"
                              )
                            }
                            valueContent={
                              this.props.gutterSpaceMobileRight
                                ? this.props.gutterSpaceMobileRight
                                : this.props.gutterSpaceMobile
                                ? this.props.gutterSpaceMobile
                                : "0"
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "gutterSpaceMobileRight");
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                this.props.gutterSpaceMobileRight
                                  ? this.props.gutterSpaceMobileRight
                                  : this.props.gutterSpaceMobile
                                  ? this.props.gutterSpaceMobile
                                  : "0",
                                "gutterSpaceMobileRight"
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="padding-section"
                    style={{ marginTop: "30px", marginBottom: "20px" }}
                  >
                    <div className="heading">Border</div>
                  </div>
                  <div
                    className="modalContentWrapper"
                    style={{ display: "flex", flexDirection: "row" }}
                  >
                    <div id={this.props.ID}>
                      <Counter
                        label="Border Width"
                        minusClick={() =>
                          this.counterMinus(
                            this.props.BorderWidth,
                            "borderWidth"
                          )
                        }
                        valueContent={this.props.BorderWidth}
                        disabled={false}
                        onChange={(e) => {
                          this.counterChange(e, "borderWidth");
                        }}
                        plusClick={() =>
                          this.counterPlus(
                            this.props.BorderWidth,
                            "borderWidth"
                          )
                        }
                      />
                    </div>
                    <div
                      style={{
                        marginLeft: "10px",
                        marginTop: "20px",
                        width: "300px",
                      }}
                      className="bgButtonWrapper col-sm-4"
                    >
                      <ColorPicker
                        btnLabel="Border Color"
                        colorValue={this.props.BorderColor}
                        colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                        getColor={(e) => {
                          this.bgColorhandleChange(e, "borderColor");
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className="padding-section"
                    style={{ marginTop: "30px", marginBottom: "5px" }}
                  >
                    <div className="heading">Background</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flexWrap: "wrap",
                    }}
                    className="modalContentWrapper"
                  >
                    <div style={{ width: "300px" }} className="">
                      <div className="section">
                        <ColorPicker
                          btnLabel="Column Background Color"
                          colorValue={this.props.BGColor}
                          colorDefaultValue={{ r: 252, g: 252, b: 252, a: 1 }}
                          getColor={(e) => {
                            this.bgColorhandleChange(e, "bgColor");
                          }}
                        />
                      </div>
                      <div className="clearfix"></div>
                    </div>
                    <div className="">
                      <button
                        onClick={() => {
                          this.setState({
                            enableLibrary: this.state.enableLibrary
                              ? false
                              : true,
                            cropImage: null,
                          });
                        }}
                        className="select-various-content-button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17.8"
                          height="17.8"
                          viewBox="0 0 17.8 17.8"
                        >
                          <g id="image" transform="translate(-0.6 -2.1)">
                            <rect
                              id="Rectangle_733"
                              data-name="Rectangle 733"
                              width="16"
                              height="16"
                              rx="2"
                              transform="translate(1.5 3)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.8"
                            />
                            <circle
                              id="Ellipse_10"
                              data-name="Ellipse 10"
                              cx="1.5"
                              cy="1.5"
                              r="1.5"
                              transform="translate(4.467 6.467)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.8"
                            />
                            <path
                              id="Path_348"
                              data-name="Path 348"
                              d="M18.4,14.5,14.537,10,4,20"
                              transform="translate(-2 -2)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.8"
                            />
                          </g>
                        </svg>
                        {this.props.BgImage ? "Change" : "Add"} Column
                        Background
                      </button>

                      {this.props.BgImage ? (
                        <Fragment>
                          <button
                            onClick={() => {
                              this.setState({
                                toggleBackgroundSettings:
                                  !this.state.toggleBackgroundSettings,
                              });
                            }}
                            className={
                              "deleteBackgroundIcon settingBackground " +
                              (this.state.toggleBackgroundSettings
                                ? " active"
                                : " ")
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="19.455"
                              height="20.001"
                              viewBox="0 0 19.455 20.001"
                            >
                              <path
                                id="Icon"
                                d="M216,440h-4a.488.488,0,0,1-.49-.42l-.38-2.65a7.376,7.376,0,0,1-1.69-.98l-2.49,1a.467.467,0,0,1-.169.03.5.5,0,0,1-.44-.25l-2-3.46a.5.5,0,0,1,.121-.64l2.11-1.65a8.111,8.111,0,0,1-.07-.98,7.937,7.937,0,0,1,.07-.98l-2.11-1.651a.491.491,0,0,1-.121-.64l2-3.46a.492.492,0,0,1,.429-.25.569.569,0,0,1,.18.03l2.49,1a7.645,7.645,0,0,1,1.69-.979l.38-2.65A.488.488,0,0,1,212,420h4a.488.488,0,0,1,.49.42l.381,2.651a7.361,7.361,0,0,1,1.689.979l2.49-1a.471.471,0,0,1,.17-.03.5.5,0,0,1,.44.25l2,3.46a.5.5,0,0,1-.12.64l-2.111,1.651a6.876,6.876,0,0,1,0,1.96l2.111,1.65a.5.5,0,0,1,.12.64l-2,3.46a.493.493,0,0,1-.43.25.57.57,0,0,1-.18-.03l-2.49-1a7.634,7.634,0,0,1-1.689.98l-.381,2.65A.488.488,0,0,1,216,440Zm-6.25-6.32h0l.91.7a5.669,5.669,0,0,0,1.229.71l1.06.43.16,1.13L213.3,438h1.4l.2-1.351.16-1.13,1.059-.43a5.836,5.836,0,0,0,1.25-.73l.9-.68,1.04.419,1.27.51.7-1.211-1.08-.84-.89-.7.139-1.13c.029-.281.05-.513.05-.73a5.236,5.236,0,0,0-.05-.73l-.139-1.13.89-.7,1.069-.85-.7-1.211-1.27.51-1.06.43-.91-.7a5.681,5.681,0,0,0-1.23-.71l-1.06-.43-.16-1.13-.19-1.35H213.3l-.2,1.35-.16,1.13-1.06.43a5.853,5.853,0,0,0-1.25.73l-.9.68-1.04-.42-1.27-.51-.7,1.211,1.08.84.89.7-.14,1.13c-.031.316-.049.537-.049.73s.021.446.049.74l.14,1.13-.89.7-1.08.841.7,1.21,1.27-.51,1.059-.429ZM214,434a4,4,0,1,1,4-4A4,4,0,0,1,214,434Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,214,428Z"
                                transform="translate(-204.271 -419.999)"
                                fill="#0c3254"
                              />
                            </svg>
                          </button>
                          <button
                            onClick={this.resetBackground}
                            className="deleteBackgroundIcon"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <g id="delete" transform="translate(34.5 5.5)">
                                <g id="trash" transform="translate(-32.5 -3.5)">
                                  <path
                                    id="Path_363"
                                    data-name="Path 363"
                                    d="M3,6H16.539"
                                    transform="translate(0 -0.991)"
                                    fill="none"
                                    stroke="#0c3254"
                                    strokeLinecap="square"
                                    strokeWidth="1.3"
                                  />
                                  <path
                                    id="Path_364"
                                    data-name="Path 364"
                                    d="M15.53,5.009v10.53a1.5,1.5,0,0,1-1.5,1.5H6.5a1.5,1.5,0,0,1-1.5-1.5V5.009m2.257,0V3.5A1.5,1.5,0,0,1,8.761,2H11.77a1.5,1.5,0,0,1,1.5,1.5v1.5"
                                    transform="translate(-0.496)"
                                    fill="none"
                                    stroke="#0c3254"
                                    strokeLinecap="square"
                                    strokeWidth="1.3"
                                  />
                                  <line
                                    id="Line_64"
                                    data-name="Line 64"
                                    y2="4.513"
                                    transform="translate(8.265 8.77)"
                                    fill="none"
                                    stroke="#0c3254"
                                    strokeLinecap="square"
                                    strokeWidth="1.3"
                                  />
                                  <line
                                    id="Line_65"
                                    data-name="Line 65"
                                    y2="4.513"
                                    transform="translate(11.274 8.77)"
                                    fill="none"
                                    stroke="#0c3254"
                                    strokeLinecap="square"
                                    strokeWidth="1.3"
                                  />
                                </g>
                              </g>
                            </svg>
                          </button>
                        </Fragment>
                      ) : null}
                    </div>
                    {this.props.BgImage &&
                    this.state.toggleBackgroundSettings ? (
                      <Fragment>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <img
                            style={{
                              marginTop: "20px",
                              marginBottom: "20px",
                              width: "300px",
                              height: "auto",
                              boxShadow: "0 0 10px 0px #0078ff",
                              border: "solid 1px #0078ff",
                            }}
                            src={this.props.BgImage}
                          />
                        </div>

                        <div
                          className="row backgroundImageProperties columnCropBg"
                          style={{ marginBottom: "25px" }}
                        >
                          <div className="col-sm-6 bgRepeatWrapper">
                            <label>Background Repeat</label>
                            <div className="radiusToggle">
                              <input
                                onChange={this.bgRepeat}
                                type="checkbox"
                                id="switch"
                                checked={this.props.BGRepeat == "repeat"}
                              />
                            </div>
                            <span>{this.props.BGRepeat}</span>
                          </div>
                          <div className="col-sm-6 bgRepeatWrapper">
                            <label>Background Size</label>
                            <div className="radiusToggle">
                              <input
                                disabled={
                                  this.props.BGRepeat == "repeat" ? true : false
                                }
                                onChange={this.bgSize}
                                type="checkbox"
                                id="size"
                                checked={this.props.BGSize == "cover"}
                              />
                            </div>
                            <span>{this.props.BGSize}</span>
                          </div>
                        </div>
                      </Fragment>
                    ) : (
                      ""
                    )}

                    {this.state.enableLibrary &&
                      this.state.cropImage == null && (
                        <div className="libraryContent selectVideo">
                          <TabContent>
                            <TabPane>
                              <ImagesContent
                                userID={this.props.userID}
                                sessionID={this.props.sessionID}
                                modalUpload={this.props.modalUpload}
                                ID={this.props.ID}
                                chooseImageForParent={this.selectBgImage}
                                forParentContent={true}
                                selectingContent={true}
                                closeImageLibrary={() => {
                                  this.setState({
                                    enableLibrary: false,
                                  });
                                }}
                                initP={this.props.initP}
                                addImage={this.props.addImage}
                                opacity={this.props.opacity}
                                radius={this.props.radius}
                                float={this.props.float}
                              />
                            </TabPane>
                          </TabContent>
                        </div>
                      )}
                  </div>
                  <div
                    className="padding-section"
                    style={{ marginTop: "30px", marginBottom: "5px" }}
                  >
                    <div className="heading">Display</div>
                  </div>
                  <div className="modalContentWrapper">
                    <label>Hide column on mobile</label>
                    <input
                      key={Math.random()}
                      className="checkMark"
                      type="checkbox"
                      id="hideColumnOnMobile"
                      name="hide"
                      value="percentage"
                      onChange={this.hideColumnOnMobile}
                      checked={
                        this.props.element.hideColumnOnMobile
                          ? this.props.element.hideColumnOnMobile.find(
                              (item, index) => {
                                return item == this.props.ColumnNumber;
                              }
                            )
                            ? true
                            : false
                          : false
                      }
                    />
                    <label htmlFor="hideColumnOnMobile"></label>
                    <small className="hideMobile">
                      {this.props.element.hideColumnOnMobile
                        ? this.props.element.hideColumnOnMobile.find(
                            (item, index) => {
                              return item == this.props.ColumnNumber;
                            }
                          )
                          ? ""
                          : ""
                        : ""}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    glblClrs: state.present.colorsGlobal,
    preset: state.present.preset,
    containerBg: state.present.containerBgColor,
    containerWidth: state.present.containerWidth,
    pixel: state.present.pixel,
    percentage: state.present.percentage,
    imagesGlobal: state.present.imagesGlobal,
    bgImage: state.present.bgImage,
    bgImageId: state.present.bgImageId,
    bgImageIndex: state.present.bgImageIndex,
    layoutTitle: state.present.layoutTitle,
    selectedFont: state.present.selectedFont,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    pushGlobalColorArray: (colorGlobal) =>
      dispatch(actionTypes.global_colors(colorGlobal)),
    pushGlobalColorPreset: (presetColor) =>
      dispatch(actionTypes.preset(presetColor)),
    pushBgColor: (color) => dispatch(actionTypes.add_bg(color)),
    pushSelectedFont: (font) => dispatch(actionTypes.add_font(font)),
    pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
    pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
    pushPercentage: (percentageVal) =>
      dispatch(actionTypes.percentage(percentageVal)),
    pushBGimage: (image, id) => dispatch(actionTypes.bg_image(image, id)),
    pushBGImages: (images) => dispatch(actionTypes.bg_images(images)),
    pushBGIndex: (index) => dispatch(actionTypes.bg_image_index(index)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ColumnBG);
